/* Collection page filters. Reads every product in the collection, then builds the filters from what those products really
   have: a filter only shows when it would narrow the list, so each range gets its own set. Nothing is written to any product. */
(function () {
  var root = document.querySelector('[data-iscc]');
  if (!root) return;

  var PER_PAGE = 48;
  var SHOW_VALUES = 7;
  /* Turns the reviews filter and the two review sorts off in one place */
  var USE_REVIEWS = true;

  var url = new URL(location.href);
  var state = {
    picks: {},
    min: url.searchParams.get('min') || '',
    max: url.searchParams.get('max') || '',
    rating: url.searchParams.get('rating') || '',
    stock: url.searchParams.get('stock') || '',
    sort: url.searchParams.get('sort') || 'featured',
    pg: parseInt(url.searchParams.get('pg'), 10) || 1
  };
  /* Old ?page= links counted in the theme's page size, so they land where those products now are */
  var oldPage = parseInt(url.searchParams.get('page'), 10);
  if (oldPage > 1 && !url.searchParams.get('pg')) state.pg = Math.floor((oldPage - 1) * (parseInt(root.getAttribute('data-page-size'), 10) || PER_PAGE) / PER_PAGE) + 1;
  var items = [];
  var loaded = false;
  var failed = false;
  var opened = {};
  var bestOrder = null;

  var esc = function (text) {
    return String(text == null ? '' : text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var money = function (pence) {
    return '£' + (pence / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };
  var cleanPrice = function (value) {
    var number = parseFloat(value);
    return isNaN(number) || number < 0 ? '' : String(number);
  };
  var setRange = function (min, max) {
    min = cleanPrice(min);
    max = cleanPrice(max);
    if (min !== '' && max !== '' && parseFloat(min) > parseFloat(max)) {
      var swap = min;
      min = max;
      max = swap;
    }
    state.min = min;
    state.max = max;
  };
  setRange(state.min, state.max);

  /* ---------- What each product is, read from its options and title ---------- */
  var NUMBERED = ['tube', 'thickness', 'width', 'height', 'length', 'diameter', 'capacity', 'size', 'pack', 'wheel', 'load'];
  var RULES = {"facets":[["part","Type"],["mount","Castor type"],["wheel","Wheel size"],["load","Max load"],["category","Category"],["tube","Tube size"],["colour","Colour"],["material","Material"],["finish","Finish"],["thickness","Thickness"],["width","Width"],["height","Height"],["length","Length"],["diameter","Diameter"],["capacity","Capacity"],["size","Size"],["fixing","Fixing"],["pack","Pack size"]],"colours":[["Black","\\bblack\\b"],["White","\\bwhite\\b"],["Grey","\\bgr[ae]y\\b|\\banthracite\\b"],["Silver","\\bsilver\\b"],["Red","\\bred\\b"],["Blue","\\bblue\\b"],["Green","\\bgreen\\b"],["Yellow","\\byellow\\b"],["Orange","\\borange\\b"],["Brown","\\bbrown\\b"],["Beige","\\bbeige\\b"],["Clear","\\bclear\\b|\\btransparent\\b"]],"materials":[["Stainless steel","\\bstainless( steel)?\\b"],["Galvanised steel","\\bgalvani[sz]ed( steel)?\\b"],["Mild steel","\\bmild steel\\b"],["Steel","\\bsteel\\b"],["Wrought iron","\\bwrought iron\\b"],["Cast iron","\\bcast iron\\b"],["Iron","\\biron\\b"],["Aluminium","\\balumini?um\\b"],["Brass","\\bbrass\\b"],["Bronze","\\bbronze\\b"],["EPDM","\\bepdm\\b"],["Neoprene","\\bneoprene\\b"],["Nitrile","\\bnitrile\\b"],["Silicone","\\bsilicone\\b"],["SBR rubber","\\bsbr\\b"],["Rubber","\\brubber\\b"],["PVC","\\bpvc\\b"],["HDPE","\\bhdpe\\b"],["Polyurethane","\\bpolyurethane\\b"],["Polypropylene","\\bpolypropylene\\b"],["Nylon","\\bnylon\\b"],["GRP","\\bgrp\\b"],["Composite","\\bcomposite\\b"],["Glass","\\btempered glass\\b|\\btoughened glass\\b"],["Timber","\\btimber\\b|\\bwooden\\b"]],"finishes":[["Powder coated","\\bpowder[- ]coat"],["Electrophoretic black","\\belectrophoretic\\b"],["Galvanised","\\bgalvani[sz]ed\\b"],["Polished","\\bpolished\\b|\\bmirror finish\\b"],["Satin","\\bsatin\\b"],["Anodised","\\banodi[sz]ed\\b"],["Zinc plated","\\bzinc[- ]plated\\b"]],"finishOptions":[["Powder coated","\\bpowder[- ]coat"],["Electrophoretic black","\\belectrophoretic\\b"],["Galvanised","\\bgalvani[sz]ed\\b"],["Polished","\\bpolished\\b|\\bmirror finish\\b"],["Satin","\\bsatin\\b"],["Anodised","\\banodi[sz]ed\\b"],["Zinc plated","\\bzinc[- ]plated\\b"],["Stainless steel","\\bstainless\\b"]],"parts":[["Kit","\\bkits?\\b"],["Tee","\\btees?\\b"],["Elbow","\\belbows?\\b"],["Crossover","\\bcross ?over\\b"],["Cross","\\bcross(es)?\\b"],["Base plate / flange","\\bbase plates?\\b|\\bflanges?\\b|\\bbase fix"],["Corner","\\bcorners?\\b"],["Bracket","\\bbrackets?\\b"],["Clip","\\bclips?\\b"],["End cap / top","\\bcaps?\\b|\\b(tube|post) tops?\\b"],["Socket","\\bsockets?\\b"],["Connector","\\bconnectors?\\b|\\bjoiners?\\b|\\bcouplers?\\b|\\bjoints?\\b"],["Hinge","\\bhinges?\\b"],["Latch","\\blatch(es)?\\b"],["Lock","\\blocks?\\b"],["Drop bolt","\\bdrop bolts?\\b"],["Bolt","\\bbolts?\\b"],["Screw","\\bscrews?\\b"],["Handle","\\bhandles?\\b"],["Castor","\\bcastors?\\b"],["Wheel","\\bwheels?\\b"],["Post","\\bposts?\\b|\\bstanchions?\\b"],["Tube","\\btubes?\\b|\\btubing\\b|\\bpipes?\\b"],["Bar","\\bbars?\\b"],["Plate","\\bplates?\\b"],["Panel","\\bpanels?\\b"],["Ring","\\brings?\\b"],["Collar","\\bcollars?\\b"],["Scroll","\\bscrolls?\\b"],["Railhead","\\brailheads?\\b"],["Picket","\\bpickets?\\b"],["Basket","\\bbaskets?\\b"],["Sphere","\\bspheres?\\b|\\bhemispheres?\\b"],["Rosette","\\brosettes?\\b"],["Leaf","\\bleaf\\b|\\bleaves\\b"],["Flower","\\bflowers?\\b"],["Fixing","\\bfixings?\\b"],["Hook","\\bhooks?\\b(?![- ]on)"],["Pin","\\bpins?\\b"],["Stop","\\bstops?\\b"]],"options":[["size","^((mat|roll|frame) )?sizes?\\b|^title$"],["colour","colou?r"],["finish","^finish"],["material","^material"],["thickness","thick"],["width","width"],["height","height"],["length","length"],["diameter","diameter"],["capacity","capacity"],["fixing","^fixings?"]]};
  var FACETS = RULES.facets.map(function (row) { return { key: row[0], title: row[1], order: NUMBERED.indexOf(row[0]) > -1 ? 'number' : '' }; });
  var compile = function (list) { return list.map(function (row) { return [row[0], new RegExp(row[1], 'i'), new RegExp(row[1], 'gi')]; }); };
  var COLOURS = compile(RULES.colours);
  var MATERIALS = compile(RULES.materials);
  var FINISHES = compile(RULES.finishes);
  var FINISH_OPTIONS = compile(RULES.finishOptions);
  var PARTS = compile(RULES.parts);
  var OPTION_FACETS = compile(RULES.options);
  var HEAD = /\s(?:for|with|to suit)\s|\s[-–—|]\s|[,:]/i;
  var BEFORE = /\s(?:with|for)\s/i;
  var TUBE = /(\d+(?:\.\d+)?)\s*mm\s+(?:[a-z]+\s+){0,2}?(?:tubes?|pipes?)\b/i;
  var THICK = /(\d+(?:\.\d+)?)\s*mm\s+(?:wall\s+)?thick/i;
  var WIDE = /(\d+(?:\.\d+)?)\s*(mm|cm|m)\s+(?:wide|width)\b/i;
  var LONG = /(\d+(?:\.\d+)?)\s*(mm|cm|m)\s+(?:long|length)\b/i;
  var LEN = /length:\s*(\d+(?:\.\d+)?)\s*mm/i;
  var DIA = /(\d+(?:\.\d+)?)\s*mm\s*(?:diameter|dia\b)|diameter\s*(?:of\s*)?(\d+(?:\.\d+)?)\s*mm/i;
  var PACK = /pack of (\d+)/i;
  var MEASURE = /^\d[\d.,]*\s*(mm|cm|m)?\s*(x|wide|long|thick|high)\b|^\d[\d.,]*\s*(mm|cm|m|kg|l|litres?)$/i;
  var SINGLE = /^\d[\d.,]*\s*(mm|cm|m)$/i;
  var TAIL = /\s[-–]\s(.+)$/;
  /* Nominal tube sizes and their exact sizes are the same tube */
  var TUBES = { '42mm': '42.4mm', '34mm': '33.7mm', '48mm': '48.3mm', '27mm': '26.9mm', '60mm': '60.3mm' };
  var tidy = function (value) { return value.trim().replace(/(\d)\.0+(?=\D|$)/g, '$1'); };
  /* 3m, 300cm and 3000mm are one choice */
  var inMm = function (value) {
    value = tidy(value).replace(/\s*(?:long|length|wide|width|thick|thickness|high|height)$/i, '');
    var match = value.match(/^(\d+(?:\.\d+)?)\s*(mm|cm|m)$/i);
    if (!match) return value.replace(/^0+(?=\d)/, '');
    var number = parseFloat(match[1]) * { mm: 1, cm: 10, m: 1000 }[match[2].toLowerCase()];
    return String(Math.round(number * 100) / 100) + 'mm';
  };
  var unit = function (value) {
    return tidy(value).replace(/^([\d.,]+)\s*(?:l|ltr|litres?)$/i, '$1L').replace(/^([\d.,]+)\s*kg$/i, '$1kg');
  };
  var facetsOf = function (item) {
    var facets = {};
    var add = function (key, value) {
      value = String(value).trim();
      if (!value) return;
      facets[key] = facets[key] || [];
      if (facets[key].indexOf(value) === -1) facets[key].push(value);
    };
    var title = item.t;
    var hits = function (list, text) { return list.filter(function (row) { return text.search(row[1]) > -1; }); };
    if (item.y) add('category', item.y);
    var head = title.split(HEAD)[0] || title;
    var part = hits(PARTS, head)[0];
    if (part) add('part', part[0]);
    if (part && part[0] === 'Castor') {
      var wheel = title.match(/(\d+)\s*mm\b[^-|]*castor/i);
      if (wheel) add('wheel', wheel[1] + 'mm');
      if (/swivel/i.test(title)) add('mount', /brake/i.test(title) ? 'Swivel with brake' : 'Swivel');
      else if (/fixed/i.test(title)) add('mount', 'Fixed');
      var load = title.match(/(\d+)\s*kg/i);
      if (load) add('load', load[1] + 'kg');
    }
    var tube = function (text) {
      var match = text.match(TUBE);
      if (match && parseFloat(match[1]) >= 15 && parseFloat(match[1]) <= 200) {
        var size = tidy(match[1]) + 'mm';
        add('tube', TUBES[size] || size);
      }
    };
    tube(title);
    var named = {};
    (item.o || []).forEach(function (option) {
      var name = option[0].trim().replace(/:$/, '').trim();
      var meaning = hits(OPTION_FACETS, name)[0];
      if (meaning) named[meaning[0]] = (named[meaning[0]] || []).concat(option[1]);
      option[1].forEach(function (value) {
        tube(value);
        var match = value.match(PACK);
        if (match) add('pack', 'Pack of ' + match[1]);
        match = value.match(LEN);
        if (match && parseFloat(match[1]) >= 500) add('length', inMm(match[1] + 'mm'));
        match = value.match(THICK);
        if (match) add('thickness', inMm(match[1] + 'mm'));
        match = value.match(WIDE);
        if (match) add('width', inMm(match[1] + match[2]));
        match = value.match(LONG);
        if (match) add('length', inMm(match[1] + match[2]));
      });
    });
    var pack = title.match(PACK);
    if (pack) add('pack', 'Pack of ' + pack[1]);
    var colourNamed = !!named.colour;
    Object.keys(named).forEach(function (key) {
      named[key].forEach(function (value) {
        if (key === 'colour') {
          hits(COLOURS, value).forEach(function (row) { add('colour', row[0]); });
        } else if (key === 'finish' || key === 'material') {
          var hit = hits(key === 'finish' ? FINISH_OPTIONS : MATERIALS, value)[0];
          if (hit) add(key, hit[0]);
          else if (value.length < 30) add(key, value.trim());
        } else if (key === 'size') {
          var tail = value.match(TAIL);
          if (tail) {
            hits(COLOURS, tail[1]).forEach(function (row) {
              add('colour', row[0]);
              colourNamed = true;
            });
          }
          var core = value.replace(TAIL, '').trim();
          if (MEASURE.test(core) && !THICK.test(core) && !WIDE.test(core) && !(facets.tube && SINGLE.test(core))) add('size', unit(core));
        } else {
          add(key, inMm(value));
        }
      });
    });
    if (!colourNamed) hits(COLOURS, title).forEach(function (row) { add('colour', row[0]); });
    if (!named.material) {
      var before = title.split(BEFORE)[0];
      MATERIALS.forEach(function (row) {
        if (before.search(row[1]) > -1) {
          add('material', row[0]);
          before = before.replace(row[2], ' ');
        }
      });
    }
    if (!named.finish) hits(FINISHES, title).forEach(function (row) { add('finish', row[0]); });
    if (!facets.thickness) {
      var thick = title.match(THICK);
      if (thick) add('thickness', inMm(thick[1] + 'mm'));
    }
    if (!named.diameter) {
      var dia = title.match(DIA);
      if (dia) add('diameter', inMm((dia[1] || dia[2]) + 'mm'));
    }
    return facets;
  };

  var prepare = function (list) {
    list.forEach(function (item) {
      item.rating = parseFloat(item.r) || 0;
      item.reviews = parseInt(item.n, 10) || 0;
      item.facets = facetsOf(item);
    });
    return list;
  };

  /* ---------- Filtering ---------- */
  var bands = function () {
    /* Bands follow the prices in this collection, so a range of small parts is not one lump under £25 */
    var steps = [5, 10, 15, 20, 25, 30, 40, 50, 75, 100, 150, 200, 250, 300, 400, 500, 750, 1000, 1500, 2000, 2500, 5000];
    var prices = items.map(function (item) { return item.p; }).sort(function (a, b) { return a - b; });
    if (prices.length < 4) return [];
    var cuts = [];
    [0.2, 0.4, 0.6, 0.8].forEach(function (share) {
      var price = prices[Math.floor(prices.length * share)] / 100;
      var nearest = steps.reduce(function (best, step) { return Math.abs(step - price) < Math.abs(best - price) ? step : best; }, steps[0]);
      if (cuts.indexOf(nearest) === -1) cuts.push(nearest);
    });
    cuts = cuts.filter(function (cut) { return cut > prices[0] / 100 && cut < prices[prices.length - 1] / 100; });
    if (!cuts.length) return [];
    var out = [{ label: 'Under £' + cuts[0], min: '', max: String(cuts[0]) }];
    for (var i = 1; i < cuts.length; i++) out.push({ label: '£' + cuts[i - 1] + ' to £' + cuts[i], min: String(cuts[i - 1]), max: String(cuts[i]) });
    out.push({ label: '£' + cuts[cuts.length - 1] + ' and over', min: String(cuts[cuts.length - 1]), max: '' });
    return out;
  };
  var isBand = function (min, max) {
    return bands().some(function (band) { return band.min === min && band.max === max; });
  };
  var inPrice = function (item, min, max, band) {
    var top = max === '' ? null : Math.round(parseFloat(max) * 100);
    if (min !== '' && item.p < Math.round(parseFloat(min) * 100)) return false;
    if (top !== null && (band ? item.p >= top : item.p > top)) return false;
    return true;
  };
  var filtered = function (skip) {
    var bandNow = isBand(state.min, state.max);
    return items.filter(function (item) {
      for (var key in state.picks) {
        if (key === skip || !state.picks[key].length) continue;
        var values = item.facets[key] || [];
        if (!state.picks[key].some(function (value) { return values.indexOf(value) > -1; })) return false;
      }
      if (skip !== 'price' && !inPrice(item, state.min, state.max, bandNow)) return false;
      if (skip !== 'rating' && state.rating && item.rating < parseFloat(state.rating)) return false;
      if (skip !== 'stock' && state.stock && !item.a) return false;
      return true;
    });
  };
  var sorted = function (list) {
    var title = function (item) { return item.t.replace(/^(premium|professional)\s+/i, ''); };
    var by = {
      'price-asc': function (a, b) { return a.p - b.p; },
      'price-desc': function (a, b) { return b.p - a.p; },
      rating: function (a, b) { return (b.rating - a.rating) || (b.reviews - a.reviews); },
      reviews: function (a, b) { return (b.reviews - a.reviews) || (b.rating - a.rating); },
      newest: function (a, b) { return (b.d || 0) - (a.d || 0); },
      az: function (a, b) { return title(a).localeCompare(title(b)); },
      best: function (a, b) {
        var left = bestOrder && a.h in bestOrder ? bestOrder[a.h] : 1e9;
        var right = bestOrder && b.h in bestOrder ? bestOrder[b.h] : 1e9;
        return left - right;
      }
    }[state.sort];
    return by ? list.slice().sort(by) : list.slice();
  };
  var pickCount = function () {
    var count = 0;
    for (var key in state.picks) count += state.picks[key].length;
    return count + (state.min || state.max ? 1 : 0) + (state.rating ? 1 : 0) + (state.stock ? 1 : 0);
  };

  /* ---------- Address bar: every filtered view can be shared or returned to ---------- */
  var readPicks = function () {
    FACETS.forEach(function (facet) {
      var raw = url.searchParams.get(facet.key);
      if (raw) state.picks[facet.key] = raw.split('|').filter(Boolean);
    });
  };
  var writeUrl = function () {
    var next = new URL(location.href);
    FACETS.forEach(function (facet) {
      var values = state.picks[facet.key] || [];
      if (values.length) next.searchParams.set(facet.key, values.join('|')); else next.searchParams.delete(facet.key);
    });
    ['min', 'max', 'rating', 'stock'].forEach(function (key) {
      if (state[key]) next.searchParams.set(key, state[key]); else next.searchParams.delete(key);
    });
    if (state.sort !== 'featured') next.searchParams.set('sort', state.sort); else next.searchParams.delete('sort');
    next.searchParams.delete('page');
    if (state.pg > 1) next.searchParams.set('pg', state.pg); else next.searchParams.delete('pg');
    history.replaceState(null, '', next);
  };

  /* ---------- Drawing ---------- */
  var starsHtml = function (rating) {
    return '<span class="iscs-stars" role="img" aria-label="' + rating.toFixed(1) + ' out of 5 stars"><span style="width:' + (rating / 5 * 100) + '%"></span></span>';
  };
  var base = location.pathname.split('/products')[0].replace(/\/$/, '');
  var collectionPath = base.split('/').slice(0, 3).join('/');
  var linkOf = function (item) { return collectionPath + '/products/' + item.h; };
  var cardHtml = function (item, index) {
    var image = item.img ? '<img src="' + esc(item.img) + '" alt="" width="400" height="400"' + (index < 4 ? '' : ' loading="lazy"') + '>' : '';
    var reviews = item.reviews ? '<a class="iscs-card__reviews" href="' + esc(linkOf(item)) + '#looxReviews">' + starsHtml(item.rating) + '<span>' + item.rating.toFixed(1) + ' (' + item.reviews + ')</span></a>' : '';
    var from = item.m > item.p ? '<small>From </small>' : '';
    var was = item.c > item.p ? '<s>' + money(item.c) + '</s>' : '';
    var action = !item.a ? '' : (item.v ? '<button type="button" class="iscs-card__add" data-add="' + esc(item.v) + '" data-url="' + esc(linkOf(item)) + '">Add to basket</button>' : '<a class="iscs-card__options" href="' + esc(linkOf(item)) + '">See options</a>');
    return '<li class="iscs-card"><a class="iscs-card__media" href="' + esc(linkOf(item)) + '" tabindex="-1" aria-hidden="true">' + image + '</a>' +
      '<div class="iscs-card__body"><a class="iscs-card__title" href="' + esc(linkOf(item)) + '">' + esc(item.t) + '</a>' + reviews +
      '<p class="iscs-card__price">' + from + '<strong>' + money(item.p) + '</strong>' + was + '</p>' +
      '<p class="iscs-card__stock' + (item.a ? '' : ' is-off') + '">' + (item.a ? 'In stock' : 'Currently unavailable') + '</p>' + action + '</div></li>';
  };
  var facetRows = function (facet) {
    var counts = {};
    var pool = filtered(facet.key);
    pool.forEach(function (item) {
      (item.facets[facet.key] || []).forEach(function (value) { counts[value] = (counts[value] || 0) + 1; });
    });
    /* Ticked values stay on screen even when other filters have taken them to nothing */
    (state.picks[facet.key] || []).forEach(function (value) { if (!(value in counts)) counts[value] = 0; });
    var rows = Object.keys(counts).map(function (value) { return { value: value, n: counts[value] }; });
    if (facet.order === 'number') {
      rows.sort(function (a, b) { return (parseFloat(a.value) - parseFloat(b.value)) || a.value.localeCompare(b.value); });
    } else if (facet.order === 'list') {
      rows.sort(function (a, b) { return facet.list.indexOf(a.value) - facet.list.indexOf(b.value); });
    } else {
      rows.sort(function (a, b) { return (b.n - a.n) || a.value.localeCompare(b.value); });
    }
    return rows;
  };
  /* A filter earns its place only if it can narrow the whole collection: more than one value, and no value that is unique to almost every product */
  var facetIsUseful = function (facet) {
    var counts = {};
    var tagged = 0;
    items.forEach(function (item) {
      var values = item.facets[facet.key] || [];
      if (values.length) tagged++;
      values.forEach(function (value) { counts[value] = (counts[value] || 0) + 1; });
    });
    var names = Object.keys(counts);
    if (names.length < 2) return false;
    if (tagged < 2) return false;
    if (tagged < items.length * 0.1 || (tagged < items.length * 0.25 && tagged < 8)) return false;
    /* Castor questions belong on castor pages, not on a mixed list that happens to include some */
    if (['mount', 'wheel', 'load'].indexOf(facet.key) > -1 && tagged < items.length * 0.5) return false;
    /* Category repeats the page when nearly everything here is one category */
    if (facet.key === 'category' && Math.max.apply(null, names.map(function (name) { return counts[name]; })) > items.length * 0.9) return false;
    /* A long list of values that each fit a single product narrows nothing */
    var oneOffs = names.filter(function (name) { return counts[name] === 1; }).length;
    if (names.length > 12 && oneOffs > names.length * 0.7) return false;
    return true;
  };
  var checkHtml = function (label, count, active, data, extra) {
    return '<li' + (extra ? ' data-extra' : '') + '><button type="button" class="iscs-opt iscc-check' + (active ? ' is-active' : '') + '" role="checkbox" aria-checked="' + active + '" ' + data + '>' +
      '<span class="iscc-box" aria-hidden="true"></span><span class="iscc-label">' + esc(label) + '</span><span class="iscs-opt__n">' + count + '</span></button></li>';
  };
  var sidebarHtml = function () {
    if (!loaded) return failed ? '' : '<div class="iscs-skel"></div><div class="iscs-skel"></div><div class="iscs-skel"></div>';
    if (items.length < 2) return '';
    var html = '';
    FACETS.forEach(function (facet) {
      if (!facetIsUseful(facet)) return;
      var rows = facetRows(facet);
      var picked = state.picks[facet.key] || [];
      var long = rows.length > SHOW_VALUES + 1;
      var isOpen = opened[facet.key];
      /* The short list holds the commonest values, kept in size order so it still reads as a ladder */
      var common = rows.slice().sort(function (a, b) { return b.n - a.n; }).slice(0, SHOW_VALUES).map(function (row) { return row.value; });
      html += '<section class="iscs-facet"><h2>' + esc(facet.title) + '</h2><ul role="list"' + (long && !isOpen ? ' class="is-long"' : '') + '>' + rows.map(function (row) {
        var active = picked.indexOf(row.value) > -1;
        return checkHtml(row.value, row.n, active, 'data-facet="' + esc(facet.key) + '" data-value="' + esc(row.value) + '"', long && common.indexOf(row.value) === -1 && !active);
      }).join('') + '</ul>' + (long ? '<button type="button" class="iscs-more" data-more="' + esc(facet.key) + '">' + (isOpen ? 'See less' : 'See all ' + rows.length) + '</button>' : '') + '</section>';
    });
    if (USE_REVIEWS) {
      var rated = [4, 3].map(function (stars) {
        return { stars: stars, n: filtered('rating').filter(function (item) { return item.rating >= stars; }).length };
      }).filter(function (row) { return row.n > 0; });
      /* 3 stars & up adds nothing when it finds the same products as 4 stars & up */
      if (rated.length === 2 && rated[0].n === rated[1].n && state.rating !== '3') rated.pop();
      if (rated.length) {
        html += '<section class="iscs-facet"><h2>Customer reviews</h2><ul role="list">' + rated.map(function (row) {
          var active = state.rating === String(row.stars);
          return '<li><button type="button" class="iscs-opt' + (active ? ' is-active' : '') + '" aria-pressed="' + active + '" data-set="rating" data-value="' + row.stars + '"><span>' + starsHtml(row.stars) + ' &amp; up</span><span class="iscs-opt__n">' + row.n + '</span></button></li>';
        }).join('') + '</ul></section>';
      }
    }
    var priced = filtered('price');
    var priceRows = bands().map(function (band) {
      var active = state.min === band.min && state.max === band.max;
      return { band: band, active: active, n: priced.filter(function (item) { return inPrice(item, band.min, band.max, true); }).length };
    }).filter(function (row) { return row.n > 0 || row.active; });
    if (items.some(function (item) { return item.p !== items[0].p; })) {
      html += '<section class="iscs-facet"><h2>Price</h2>' + (priceRows.length > 1 ? '<ul role="list">' + priceRows.map(function (row) {
        return '<li><button type="button" class="iscs-opt' + (row.active ? ' is-active' : '') + '" aria-pressed="' + row.active + '" data-band data-min="' + row.band.min + '" data-max="' + row.band.max + '"><span>' + esc(row.band.label) + '</span><span class="iscs-opt__n">' + row.n + '</span></button></li>';
      }).join('') + '</ul>' : '') + '<form class="iscs-range" data-range novalidate><label><span>£ Min</span><input type="number" min="0" step="any" inputmode="decimal" name="min" value="' + esc(state.min) + '"></label><label><span>£ Max</span><input type="number" min="0" step="any" inputmode="decimal" name="max" value="' + esc(state.max) + '"></label><button type="submit">Go</button></form></section>';
    }
    if (filtered('stock').some(function (item) { return !item.a; })) {
      var inStock = filtered('stock').filter(function (item) { return item.a; }).length;
      html += '<section class="iscs-facet"><h2>Availability</h2><ul role="list">' + checkHtml('In stock only', inStock, !!state.stock, 'data-set="stock" data-value="1"') + '</ul></section>';
    }
    return html;
  };
  var activeHtml = function () {
    var chips = [];
    FACETS.forEach(function (facet) {
      (state.picks[facet.key] || []).forEach(function (value) {
        chips.push(['data-remove-pick="' + esc(facet.key) + '" data-value="' + esc(value) + '"', (facet.order === 'number' ? facet.title + ': ' : '') + value]);
      });
    });
    if (state.min || state.max) chips.push(['data-remove="price"', state.min && state.max ? '£' + state.min + ' to £' + state.max : (state.max ? 'Up to £' + state.max : '£' + state.min + ' and over')]);
    if (state.rating) chips.push(['data-remove="rating"', state.rating + ' stars & up']);
    if (state.stock) chips.push(['data-remove="stock"', 'In stock only']);
    if (!chips.length) return '';
    return '<div class="iscs-active">' + chips.map(function (chip) {
      return '<button type="button" ' + chip[0] + '>' + esc(chip[1]) + '<span aria-hidden="true"> ×</span><span class="iscs-sr"> remove filter</span></button>';
    }).join('') + '<button type="button" class="iscs-active__clear" data-clear>Clear all</button></div>';
  };
  var pagerHtml = function (total) {
    var pages = Math.ceil(total / PER_PAGE);
    if (pages < 2) return '';
    var html = '<nav class="iscs-pager" aria-label="Pages">';
    html += state.pg > 1 ? '<button type="button" data-pg="' + (state.pg - 1) + '">Previous</button>' : '';
    var gapped = false;
    for (var page = 1; page <= pages; page++) {
      if (pages > 9 && page > 2 && page < pages - 1 && Math.abs(page - state.pg) > 1) {
        if (!gapped) html += '<span class="iscc-gap" aria-hidden="true">&hellip;</span>';
        gapped = true;
        continue;
      }
      gapped = false;
      html += '<button type="button" data-pg="' + page + '"' + (page === state.pg ? ' class="is-current" aria-current="page"' : '') + '>' + page + '</button>';
    }
    html += state.pg < pages ? '<button type="button" data-pg="' + (state.pg + 1) + '">Next</button>' : '';
    return html + '</nav>';
  };
  var sortOptions = function () {
    var options = [['featured', 'Featured'], ['best', 'Best selling'], ['price-asc', 'Price: low to high'], ['price-desc', 'Price: high to low']];
    if (USE_REVIEWS) options.push(['rating', 'Customer rating'], ['reviews', 'Most reviews']);
    options.push(['newest', 'Newest'], ['az', 'A to Z']);
    return options;
  };
  var draw = function () {
    /* The phone sheet and its scroll position must survive a redraw caused by ticking a box inside it */
    var side = root.querySelector('[data-sheet]');
    var sheetOpen = !!(side && side.classList.contains('is-open'));
    var sheetTop = side ? side.scrollTop : 0;
    var focused = document.activeElement && root.contains(document.activeElement) ? document.activeElement : null;
    var focusFacet = focused ? focused.getAttribute('data-facet') : null;
    var focusValue = focused ? focused.getAttribute('data-value') : null;
    var list = sorted(filtered());
    var pages = Math.max(1, Math.ceil(list.length / PER_PAGE));
    if (loaded && state.pg > pages) state.pg = pages;
    var start = (state.pg - 1) * PER_PAGE;
    var shown = loaded ? list.slice(start, start + PER_PAGE) : (pickCount() ? [] : items);
    var total = loaded ? list.length : parseInt(root.getAttribute('data-total'), 10) || list.length;
    var countText = !list.length && loaded ? 'No products match these filters' :
      (loaded ? (start + 1) + '-' + (start + shown.length) + ' of ' : '') + total + ' product' + (total === 1 ? '' : 's');
    var sideHtml = sidebarHtml();
    var count = pickCount();
    var hasSide = !loaded || sideHtml !== '';
    root.classList.toggle('iscs--basic', !hasSide);
    var empty = loaded && !list.length ? '<div class="iscs-empty"><p>No products match these filters.</p><button type="button" data-clear>Clear all filters</button></div>' : '';
    root.innerHTML = '<div class="iscs__top"><p class="iscs__count" aria-live="polite">' + countText + '</p>' +
      '<div class="iscs__tools">' + (hasSide ? '<button type="button" class="iscs__filter-btn" data-sheet-open>Filters' + (count ? ' (' + count + ')' : '') + '</button>' : '') +
      '<label class="iscs__sort"><span>Sort by:</span><select data-sort>' + sortOptions().map(function (option) {
        return '<option value="' + option[0] + '"' + (option[0] === state.sort ? ' selected' : '') + '>' + option[1] + '</option>';
      }).join('') + '</select></label></div></div>' +
      '<div class="iscs__body"><aside class="iscs__side" data-sheet aria-label="Filters"><div class="iscs__sheet-head"><strong>Filters</strong><button type="button" data-sheet-close>Show ' + (loaded ? list.length : total) + ' product' + ((loaded ? list.length : total) === 1 ? '' : 's') + '</button></div>' + sideHtml + '</aside>' +
      '<div class="iscs__main">' + activeHtml() + empty + (shown.length ? '<ul class="iscs-grid" role="list">' + shown.map(function (item, index) { return cardHtml(item, index); }).join('') + '</ul>' : '') + (loaded ? pagerHtml(list.length) : '') + '</div></div>';
    if (sheetOpen) {
      var again = root.querySelector('[data-sheet]');
      again.classList.add('is-open');
      again.scrollTop = sheetTop;
    }
    /* Keyboard users stay on the box they just ticked */
    if (focusFacet) {
      var boxes = root.querySelectorAll('[data-facet="' + focusFacet + '"]');
      for (var i = 0; i < boxes.length; i++) {
        if (boxes[i].getAttribute('data-value') === focusValue) { boxes[i].focus({ preventScroll: true }); break; }
      }
    }
  };

  /* ---------- Actions ---------- */
  var change = function () {
    state.pg = 1;
    writeUrl();
    draw();
  };
  var loadBestOrder = function () {
    if (bestOrder) return Promise.resolve();
    return readAll('best-selling').then(function (list) {
      var order = {};
      list.forEach(function (item, position) { order[item.h] = position; });
      bestOrder = order;
    });
  };
  root.addEventListener('click', function (event) {
    var target = event.target.closest('button');
    if (!target) return;
    if (target.hasAttribute('data-facet')) {
      var key = target.getAttribute('data-facet');
      var value = target.getAttribute('data-value');
      var picks = state.picks[key] = state.picks[key] || [];
      var at = picks.indexOf(value);
      if (at > -1) picks.splice(at, 1); else picks.push(value);
      change();
    } else if (target.hasAttribute('data-set')) {
      var name = target.getAttribute('data-set');
      var chosen = target.getAttribute('data-value');
      state[name] = state[name] === chosen ? '' : chosen;
      change();
    } else if (target.hasAttribute('data-band')) {
      var min = target.getAttribute('data-min');
      var max = target.getAttribute('data-max');
      var same = state.min === min && state.max === max;
      state.min = same ? '' : min;
      state.max = same ? '' : max;
      change();
    } else if (target.hasAttribute('data-remove-pick')) {
      var facet = target.getAttribute('data-remove-pick');
      state.picks[facet] = (state.picks[facet] || []).filter(function (item) { return item !== target.getAttribute('data-value'); });
      change();
    } else if (target.hasAttribute('data-remove')) {
      var what = target.getAttribute('data-remove');
      if (what === 'price') { state.min = ''; state.max = ''; } else { state[what] = ''; }
      change();
    } else if (target.hasAttribute('data-clear')) {
      state.picks = {};
      state.min = state.max = state.rating = state.stock = '';
      change();
    } else if (target.hasAttribute('data-more')) {
      var more = target.getAttribute('data-more');
      opened[more] = !opened[more];
      draw();
    } else if (target.hasAttribute('data-pg')) {
      state.pg = parseInt(target.getAttribute('data-pg'), 10);
      writeUrl();
      draw();
      window.scrollTo(0, root.getBoundingClientRect().top + window.pageYOffset - 90);
    } else if (target.hasAttribute('data-sheet-open')) {
      root.querySelector('[data-sheet]').classList.add('is-open');
      document.documentElement.classList.add('iscs-locked');
    } else if (target.hasAttribute('data-sheet-close')) {
      root.querySelector('[data-sheet]').classList.remove('is-open');
      document.documentElement.classList.remove('iscs-locked');
    } else if (target.hasAttribute('data-add')) {
      addToBasket(target);
    }
  });
  root.addEventListener('change', function (event) {
    if (!event.target.matches('[data-sort]')) return;
    var next = event.target.value;
    if (next !== 'best') {
      state.sort = next;
      change();
      return;
    }
    event.target.disabled = true;
    loadBestOrder().then(function () {
      state.sort = 'best';
      change();
    }).catch(function () {
      /* Without the sales order the list stays as it was */
      draw();
    });
  });
  root.addEventListener('submit', function (event) {
    if (!event.target.matches('[data-range]')) return;
    event.preventDefault();
    setRange(event.target.elements.min.value.trim(), event.target.elements.max.value.trim());
    change();
  });
  var addToBasket = function (button) {
    button.disabled = true;
    button.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(button.getAttribute('data-add'), 10), quantity: 1 })
    }).then(function (response) {
      if (!response.ok) throw new Error('add failed');
      return fetch('/cart.js');
    }).then(function (response) { return response.json(); }).then(function (cart) {
      Array.prototype.forEach.call(document.querySelectorAll('.header__cart-count,[data-iscn-count]'), function (count) { count.textContent = cart.item_count; });
      var view = document.createElement('a');
      view.className = 'iscs-card__added';
      view.href = '/cart';
      view.textContent = 'Added. View basket';
      button.replaceWith(view);
    }).catch(function () {
      /* The product page explains anything that stops it being added */
      location.href = button.getAttribute('data-url');
    });
  };

  /* ---------- Start: this page's products straight away, then everything else ---------- */
  var fetchPage = function (page, sortBy) {
    var link = new URL(location.pathname, location.origin);
    link.searchParams.set('view', 'iscdata');
    link.searchParams.set('page', page);
    if (sortBy) link.searchParams.set('sort_by', sortBy);
    var theme = url.searchParams.get('preview_theme_id');
    if (theme) link.searchParams.set('preview_theme_id', theme);
    return fetch(link.toString(), { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('collection data ' + response.status);
      return response.json();
    });
  };
  /* The first page says how many there are, then the rest come three at a time and keep their order */
  var readAll = function (sortBy) {
    return fetchPage(1, sortBy).then(function (data) {
      var pages = [data.items];
      var next = 2;
      var worker = function () {
        if (next > data.pages) return Promise.resolve();
        var page = next++;
        return fetchPage(page, sortBy).then(function (more) {
          pages[page - 1] = more.items;
          return worker();
        });
      };
      return Promise.all([worker(), worker(), worker()]).then(function () {
        return pages.reduce(function (all, list) { return all.concat(list); }, []);
      });
    });
  };
  var first = document.getElementById('iscc-first');
  try { items = prepare(JSON.parse(first.textContent)); } catch (e) { items = []; }
  readPicks();
  /* A filtered address can't be honoured until everything is read, so it waits on the skeleton rather than flashing the wrong products */

  /* Coming back from a product should be instant, so a read is kept for this tab for ten minutes */
  var cacheKey = 'iscc:' + (window.Shopify && Shopify.theme ? Shopify.theme.id : '') + ':' + location.pathname + ':' + (url.searchParams.get('sort_by') || '');
  var readCache = function () {
    try {
      var saved = JSON.parse(sessionStorage.getItem(cacheKey));
      return saved && Date.now() - saved.at < 600000 ? saved.items : null;
    } catch (e) { return null; }
  };
  var writeCache = function (raw) {
    if (raw.length > 1000) return;
    try { sessionStorage.setItem(cacheKey, JSON.stringify({ at: Date.now(), items: raw })); } catch (e) { /* A full or blocked store only costs a re-read */ }
  };
  var finish = function (raw) {
    items = prepare(raw);
    loaded = true;
    writeUrl();
    draw();
    if (state.sort === 'best') {
      loadBestOrder().then(draw).catch(function () { state.sort = 'featured'; draw(); });
    }
  };
  var cached = readCache();
  if (cached) {
    finish(cached);
    return;
  }
  draw();

  readAll(url.searchParams.get('sort_by')).then(function (everything) {
    writeCache(everything);
    finish(everything);
  }).catch(function () {
    /* The products on screen are still right; only the filters are missing */
    failed = true;
    loaded = true;
    var fallback = document.querySelector('.iscc-fallback');
    if (fallback) {
      fallback.classList.remove('iscc-fallback');
      root.style.display = 'none';
    }
  });
})();
